const filterMapper = {
  tumu: 'Tümü',
  bugün: 'Bugün',
  yarın: 'Yarın',
  pzt: 'Pazartesi',
  sal: 'Salı',
  car: 'Çarşamba',
  per: 'Perşembe',
  cum: 'Cuma',
  cmt: 'Cumartesi',
  paz: 'Pazar'
};

const filterNameFixer = val => {
  if (Object.keys(filterMapper)?.find(e => e === val?.toLowerCase())) {
    return filterMapper[val?.toLowerCase()];
  }
  return val;
};

const nameReplacer = val => {
  let name = val;
  if (name?.includes(':')) {
    name = filterNameFixer(name?.split(':')[1]);
  }
  return name;
};

export const mixpanelFilterParser = (filters, property) => {
  const data = filters?.filterRequestType?.find(filter => filter?.filterType === property)?.filterIds?.map(filter => nameReplacer(filter)) || '-';

  return data;
};